


































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { FormPlugin } from '@/models'

@Component({
	components: {},
})
export default class DialogoDeEdicaoDePlugin extends Vue {
	@Ref() form!: HTMLFormElement

	plugin: FormPlugin | null = null
	mostra = false
	salvando = false
	chave = ''
	valor = ''

	get configs() {
		if (this.plugin) {
			return Object.entries(this.plugin?.configs).map(([chave, valor]) => {
				return { chave, valor }
			})
		}
		return []
	}

	adicionarConfig() {
		if (this.plugin) {
			this.$set(this.plugin.configs, this.chave, this.valor)
			this.chave = ''
			this.valor = ''
		}
	}

	excluirConfig(chave) {
		if (this.plugin) {
			this.$delete(this.plugin.configs, chave)
		}
	}

	alterarConfig(chaveValor) {
		if (this.plugin) {
			this.$set(this.plugin.configs, chaveValor.chave, chaveValor.valor)
		}
	}

	mostrar(plugin: FormPlugin) {
		this.plugin = plugin
		this.mostra = true

		setTimeout(() => {
			this.form.resetValidation()
		})
	}

	esconder() {
		this.mostra = false
	}

	salvar() {
		this.mostra = false
		this.$emit('confirmado', this.plugin)
	}
}
